import { configureStore } from '@reduxjs/toolkit';
import timelineReducer from './components/Timeline/timelineSlice';
import businessReducer from './components/Business/businessSlice';

export default configureStore({
  reducer: {
      dates: timelineReducer,
      businesses: businessReducer
  }
})